import React,{useState,useEffect} from 'react'
import Main from '../../cpn/Main'
import { Table,Space,DatePicker, Radio, Button, Modal, Flex, Descriptions} from 'antd'
import {  useQtszDeptProfitQuery } from '../../store/ReactWebSiteApi';
import dayjs from 'dayjs';
const {RangePicker} = DatePicker
function ElseSumDept() {
    const [open,setOpen] = useState(false)
    const [info,setInfo] = useState({
        s_date:'',
        e_date:'',
        ebn_audit:'0',
        name:'全部'
    })
    
    const {data,isSuccess} = useQtszDeptProfitQuery({
        e_id:localStorage.getItem('e_id'),
        eie_type_id:'4,5',
        s_date:info.s_date,
        e_date:info.e_date,
    },{refetchOnMountOrArgChange:1,skip:!open});
    
    const [list, setList] = useState();
    
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                console.log(data);
                
                const newArr = data.Result.map(item => {
                    const {ed_id:key,ed_name,type4,type5,} = item;
                    return item = {key,ed_name,type4,type5,}
                })                
                
                setList(newArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])    
    const columns = [
                  
        {
            key: '1',
            title: '部门',
            dataIndex: 'ed_name',
        },                
        {
            key: '3',
            title: '其他收入单合计',
            dataIndex:'type4'
        },     
        {
            key: '4',
            title: '其他支出单合计',
            dataIndex:'type5',
        },     
        {
            key: '5',
            title: '差额',
            render:(_,record) => {
                return <>{(+record.type4 + +record.type5).toFixed(2)}</>
            }
        },     
       
    ]
    const items = [        
        {
            key:'1',
            label:'其他收支单的新增日期',
            children:<>{info.s_date}至{info.e_date}</>,
        },
       
        {
            key:'3',
            label:'制表人',
            children:<>{localStorage.getItem('ed_name').replace(/"/g,'')} / {localStorage.getItem('eu_name').replace(/"/g,'')}</>,
            span:2,
        },
        {
            key:'2',
            label:'审核',
            children:<>{info.name}</>,
            
        },
        {
            key:'4',
            label:'制表时间',
            children:<>{dayjs().format('YYYY-MM-DD HH:MM:ss')}</>
        },
    ]
    return (
        <Main t1='财务'  t2='其他收支' n2='/ElseIndex' t3='报表' n3='/ElseTable' t4='部门其他收支表' >
            <Space>
                <span>其他收支单的新增日期：</span>
                <RangePicker
                    onChange={(e) => {
                        if(e){
                            setInfo(prevState=>({...prevState,s_date:dayjs(e[0]).format('YYYY-MM-DD'),e_date:dayjs(e[1]).format('YYYY-MM-DD')})) 
                        }else{
                            setInfo(prevState=>({...prevState,s_date:'',e_date:''}))
                        }
                    }}
                />
                <Radio.Group 
                    optionType='button' 
                    onChange={(e) => {
                        let name 
                        if(e.target.value==='0'){
                            name='全部'
                        }else if(e.target.value==='1'){
                            name='已审核'
                        }else{
                            name='未审核'
                        }
                        setInfo(prevState=>({...prevState,ebn_audit:e.target.value,name}))
                    }} 
                    value={info.ebn_audit}
                >
                    <Radio value='0'>全部</Radio>
                    <Radio value='1'>已审核</Radio>
                    <Radio value='2'>未审核</Radio>
                </Radio.Group>
                <Button type='primary' onClick={() => {setOpen(true)}}>查询</Button>
            </Space>
            <Modal
                open={open}
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false)}}
                width={1200}
                footer={null}
            >            
                <Flex justify='center'>
                    <h2>部门其他收支表</h2>
                </Flex>
                <Descriptions items={items} bordered/>
                <Table 
                    columns={columns} 
                    dataSource={list} 
                    pagination={{position:['none'],defaultPageSize:100}}
                    summary={(pageData) => {
                        console.log(pageData);
                        let totalincome_num = 0;
                        let totalnexpenditure_num = 0;
                        pageData.forEach(({type4, type5, }) => {
                            totalincome_num += +type4;
                            totalnexpenditure_num += +type5;
                        });
                        return <Table.Summary>
                                    <Table.Summary.Row>
                                        <Table.Summary.Cell index={0}>合计</Table.Summary.Cell>
                                        <Table.Summary.Cell index={1}>{(totalincome_num).toFixed(2)}</Table.Summary.Cell>
                                        <Table.Summary.Cell index={2}>{(totalnexpenditure_num).toFixed(2)}</Table.Summary.Cell>
                                        <Table.Summary.Cell index={3}>{(totalincome_num+totalnexpenditure_num).toFixed(2)}</Table.Summary.Cell>
                                    </Table.Summary.Row>
                                </Table.Summary>
                    }}
                />   
            </Modal>
        </Main>
    )
}

export default ElseSumDept